import React from 'react';
import { ContentSectionWrap, LinkWrap } from '../common-styles.styles';

const LinksBlock = props => {
  const { title, links, isDweb = false } = props;

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <ContentSectionWrap isDweb={isDweb}>
      <div className="marginB15">
        <span
          className={`${!isDweb ? 'font12' : 'font10'} quicksand fb`}
          style={isDweb ? { color: '#141823' } : {}}
        >
          {title}
        </span>
      </div>
      <div className="contentSection dF fGS0 flexWrap">
        {links.map((link, index) => (
          <LinkWrap href={`https://${link.url}`} className="searchTabsBtn" key={index}>
            {link.name}
          </LinkWrap>
        ))}
      </div>
    </ContentSectionWrap>
  );
};

export default LinksBlock;
